module.exports = __webpack_public_path__ + "static/technology-and-nature-b6ef485babdd3e62275c2343c17b7b3d.jpg";